import React from 'react';
import {publicUrl} from 'lib/head';
import {PageMetadata} from './PageMetadata';

export function withApplicationMetadata(
  Component,
  /**
   * By default the `getMetadataFromProps` function will use `title` and `metaDescription` attributes on the `route`.
   * It may also return `canonicalPath`, e.g. `/ap-biology`, to set the page's canonical URL.
   */
  getMetadataFromProps = (props) => ({
    title: props.route.title,
    metaDescription: props.route.metaDescription
  })
) {
  return class WithMetadata extends React.Component {
    static displayName = `WithMetadata(${Component.displayName || Component.name || 'Component'})`;
    render() {
      const metadata = getMetadataFromProps(this.props);
      return (
        <React.Fragment>
          <PageMetadata
            {...metadata}
            canonicalUrl={metadata.canonicalPath ? publicUrl(metadata.canonicalPath) : undefined}
          />
          <Component {...this.props} />
        </React.Fragment>
      );
    }
  };
}
